import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { DfUiModule } from '@df/ui/df-ui.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import take from 'lodash-es/take';
import SwiperCore, { Scrollbar } from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { ProductViewLayoutComponent } from '../view-layout/product-view-layout.component';
import { RecommendationItemDataComponent } from './recommendation-item.component';
// install Swiper modules
SwiperCore.use([Scrollbar]);
@Component({
    selector: 'product-view-fashion-recommendation',
    templateUrl: './product-view-fashion-recommendation.html',
    standalone: true,
    imports: [ICmsClientModule, DfUiModule, RecommendationItemDataComponent, SwiperModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewFashionRecommendationComponent extends UiComponent {
    @Input({
        required: true
    })
    product!: Product<IProductDataV3>;
    constructor(readonly productViewLayout: ProductViewLayoutComponent) {
        super();
    }
    get recommendations(): number[] | undefined {
        const ids = this.product.getAttr<number[]>('fashion_recommendation');
        return ids && Array.isArray(ids) ? take(ids, 3) : undefined;
    }
}
